var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 9.99935C1.66699 5.40435 5.40533 1.66602 10.0003 1.66602C14.5953 1.66602 18.3337 5.40435 18.3337 9.99935C18.3337 14.5943 14.5953 18.3327 10.0003 18.3327C5.40533 18.3327 1.66699 14.5943 1.66699 9.99935ZM10.0003 16.666C6.32449 16.666 3.33366 13.6752 3.33366 9.99935C3.33366 6.32352 6.32449 3.33268 10.0003 3.33268C13.6762 3.33268 16.667 6.32352 16.667 9.99935C16.667 13.6752 13.6762 16.666 10.0003 16.666ZM12.5003 9.16602H10.8337V7.49935C10.8337 7.04102 10.4587 6.66602 10.0003 6.66602C9.54199 6.66602 9.16699 7.04102 9.16699 7.49935V9.16602H7.50033C7.04199 9.16602 6.66699 9.54102 6.66699 9.99935C6.66699 10.4577 7.04199 10.8327 7.50033 10.8327H9.16699V12.4993C9.16699 12.9577 9.54199 13.3327 10.0003 13.3327C10.4587 13.3327 10.8337 12.9577 10.8337 12.4993V10.8327H12.5003C12.9587 10.8327 13.3337 10.4577 13.3337 9.99935C13.3337 9.54102 12.9587 9.16602 12.5003 9.16602Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11854_54099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 9.99935C1.66699 5.40435 5.40533 1.66602 10.0003 1.66602C14.5953 1.66602 18.3337 5.40435 18.3337 9.99935C18.3337 14.5943 14.5953 18.3327 10.0003 18.3327C5.40533 18.3327 1.66699 14.5943 1.66699 9.99935ZM10.0003 16.666C6.32449 16.666 3.33366 13.6752 3.33366 9.99935C3.33366 6.32352 6.32449 3.33268 10.0003 3.33268C13.6762 3.33268 16.667 6.32352 16.667 9.99935C16.667 13.6752 13.6762 16.666 10.0003 16.666ZM12.5003 9.16602H10.8337V7.49935C10.8337 7.04102 10.4587 6.66602 10.0003 6.66602C9.54199 6.66602 9.16699 7.04102 9.16699 7.49935V9.16602H7.50033C7.04199 9.16602 6.66699 9.54102 6.66699 9.99935C6.66699 10.4577 7.04199 10.8327 7.50033 10.8327H9.16699V12.4993C9.16699 12.9577 9.54199 13.3327 10.0003 13.3327C10.4587 13.3327 10.8337 12.9577 10.8337 12.4993V10.8327H12.5003C12.9587 10.8327 13.3337 10.4577 13.3337 9.99935C13.3337 9.54102 12.9587 9.16602 12.5003 9.16602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11854_54099)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlusCircle);
export default __webpack_public_path__ + "static/media/add-plus-circle.a4f39709d31944838e9f715aeae8c46a.svg";
export { ForwardRef as ReactComponent };